import { apiSlice } from './apiSlice.js';

export const adminOpsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminAuditLogs: builder.query({
      query: ({ page = 1, pageSize = 25, q = '' } = {}) => ({
        url: '/api/admin/ops/audit',
        params: { page, pageSize, q },
      }),
      keepUnusedDataFor: 5,
    }),
    getFraudEvents: builder.query({
      query: ({ page = 1, pageSize = 25, status = '' } = {}) => ({
        url: '/api/admin/ops/fraud',
        params: { page, pageSize, status },
      }),
      keepUnusedDataFor: 5,
    }),
    setFraudEventStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/api/admin/ops/fraud/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
    }),
    getMonitoringSummary: builder.query({
      query: () => '/api/admin/ops/monitoring/summary',
      keepUnusedDataFor: 5,
    }),
    getIncidents: builder.query({
      query: ({ status = '' } = {}) => ({
        url: '/api/admin/ops/incidents',
        params: { status },
      }),
      keepUnusedDataFor: 5,
    }),
    createIncident: builder.mutation({
      query: (payload) => ({
        url: '/api/admin/ops/incidents',
        method: 'POST',
        body: payload,
      }),
    }),
    refreshIncidents: builder.mutation({
      query: () => ({
        url: '/api/admin/ops/incidents/refresh',
        method: 'POST',
      }),
    }),
    acknowledgeIncident: builder.mutation({
      query: (id) => ({
        url: `/api/admin/ops/incidents/${id}/ack`,
        method: 'PUT',
      }),
    }),
    resolveIncident: builder.mutation({
      query: (id) => ({
        url: `/api/admin/ops/incidents/${id}/resolve`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useGetAdminAuditLogsQuery,
  useGetFraudEventsQuery,
  useSetFraudEventStatusMutation,
  useGetMonitoringSummaryQuery,
  useGetIncidentsQuery,
  useCreateIncidentMutation,
  useRefreshIncidentsMutation,
  useAcknowledgeIncidentMutation,
  useResolveIncidentMutation,
} = adminOpsApiSlice;

